import type { Calculation } from '../../../Entities/Calculation.entity';

export const totalDepositContribution = (
  calculation: Calculation,
  selectedProduct: string,
): {
  depositContribution: number | undefined;
  isDepositContribution: boolean;
  totalContribution: number | undefined;
  isTotalContribution: boolean;
} => {
  const depositContribution =
    calculation?.products?.[selectedProduct]?.calculationResult.totalContribution;

  const isDepositContribution = depositContribution !== undefined && depositContribution > 0;

  const totalContribution =
    calculation?.products?.[selectedProduct]?.calculationResult.totalDeposit;

  const isTotalContribution = totalContribution !== undefined && totalContribution > 0;

  return { depositContribution, isDepositContribution, totalContribution, isTotalContribution };
};
